/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Mapa oddzialow Totalizatora Sportowego — ladowanie na zadanie.
 *
 * Zasada: dopoki uzytkownik nie kliknie przycisku, nie leci ANI JEDNO
 * zapytanie do obcego serwera. Statyczny SVG w HTML pokazuje rozmieszczenie,
 * pelna lista adresow jest ponizej — mapa jest dodatkiem, nie warunkiem
 * dotarcia do informacji.
 *
 * Leaflet serwujemy z wlasnego serwera. CDN wysylalby adres IP uzytkownika
 * do obcego hosta jeszcze zanim cokolwiek by sie wyswietlilo, wiec caly sens
 * ladowania na zadanie by przepadl.
 *
 * Kafelki i tak pochodza z OpenStreetMap — dlatego dopiero po kliknieciu.
 */
(function () {
    'use strict';
 function enText(pl,en){return /^en(?:-|$)/i.test(document.documentElement.lang||'')?en:pl;}

    var LEAFLET_CSS = '/assets/css/leaflet.css';
    var LEAFLET_JS  = '/assets/js/leaflet.js';

    var przycisk = document.querySelector('[data-mapa-wlacz]');
    var kontener = document.querySelector('[data-mapa]');
    var statyczna = document.getElementById('mapa-statyczna');

    if (!przycisk || !kontener) {
        return;
    }

    // Przycisk jest w HTML ukryty. Odslaniamy go dopiero tutaj, bo bez JS
    // klikniecie i tak nic by nie dalo — a martwy przycisk to gorzej niz brak.
    przycisk.hidden = false;

    var punkty = [];
    try {
        punkty = JSON.parse(kontener.dataset.mapaPunkty || '[]');
    } catch (e) {
        return;
    }
    if (!punkty.length) {
        przycisk.hidden = true;
        return;
    }

    var zaladowano = false;

    function wczytajStyl(url) {
        return new Promise(function (ok, blad) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.onload = ok;
            link.onerror = blad;
            document.head.appendChild(link);
        });
    }

    function wczytajSkrypt(url) {
        return new Promise(function (ok, blad) {
            var s = document.createElement('script');
            s.src = url;
            s.onload = ok;
            s.onerror = blad;
            document.head.appendChild(s);
        });
    }

    function escHtml(t) {
        var d = document.createElement('div');
        d.textContent = t == null ? '' : String(t);
        return d.innerHTML;
    }

    function dymek(p) {
        var czesci = ['<strong>' + escHtml(p.name || p.city) + '</strong>'];
        if (p.address) { czesci.push(escHtml(p.address.trim())); }
        var wiersz = '';
        if (p.zipCode) { wiersz += escHtml(p.zipCode.trim()) + ' '; }
        if (p.city) { wiersz += escHtml(p.city.trim()); }
        if (wiersz.trim()) { czesci.push(wiersz); }
        if (p.phoneNumber) {
            var tel = String(p.phoneNumber).trim();
            czesci.push(jst("fragment.1aaf81483417b179") + escHtml(tel.replace(/[\s-]/g, '')) + '">' + escHtml(tel) + '</a>');
        }
        if (p.slug) {
            czesci.push(jst("fragment.c6ec6b14ed2cbb2b") + encodeURIComponent(p.slug) + '">' + jst("mapa_js.af0e59ba5c19") + '</a>');
        }
        return czesci.join('<br>');
    }

    function rysuj() {
        if (typeof L === 'undefined') {
            return;
        }

        var mapa = L.map(kontener, { scrollWheelZoom: false });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: jst("ui.6f247b87430295cf")
        }).addTo(mapa);

        var wspolrzedne = [];
        punkty.forEach(function (p) {
            // gpsX to szerokosc, gpsY dlugosc — nazwy z API sa mylace,
            // odwrocenie ich wrzuca wszystkie punkty do Morza Czarnego.
            var lat = parseFloat(p.gpsX);
            var lon = parseFloat(p.gpsY);
            if (!isFinite(lat) || !isFinite(lon) || lat === 0 || lon === 0) {
                return;
            }
            // circleMarker, NIE marker. Domyslna pinezka Leafletu to obrazek
            // `images/marker-icon.png` szukany obok leaflet.css — tego katalogu
            // nie pobralismy, wiec przegladarka rysowala ramke z tekstem
            // zastepczym „Mark" w kazdym z siedemnastu miejsc (12.09.2026).
            // Kolko rysuje sie wektorowo: zero plikow, zero zadan do serwera
            // i ten sam czerwony punkt co na obrysie, ktory tu byl wczesniej.
            L.circleMarker([lat, lon], {
                radius: 8,
                color: '#FFFFFF',
                weight: 2,
                fillColor: '#DC2626',
                fillOpacity: 1
            }).addTo(mapa).bindPopup(dymek(p));
            wspolrzedne.push([lat, lon]);
        });

        if (!wspolrzedne.length) {
            return;
        }

        var zoom = parseInt(kontener.dataset.mapaZoom || '0', 10);
        if (wspolrzedne.length === 1) {
            mapa.setView(wspolrzedne[0], zoom > 0 ? zoom : 15);
        } else {
            mapa.fitBounds(wspolrzedne, { padding: [24, 24] });
        }

        // Kontener wstawiony jako hidden ma zerowa wysokosc w chwili
        // inicjalizacji — bez tego kafelki laduja sie w rogu.
        setTimeout(function () { mapa.invalidateSize(); }, 0);
    }

    przycisk.addEventListener('click', function () {
        if (zaladowano) {
            return;
        }
        zaladowano = true;
        przycisk.disabled = true;
        przycisk.textContent = jst("mapa_js.a3d1a2fb0b86");

        Promise.all([wczytajStyl(LEAFLET_CSS), wczytajSkrypt(LEAFLET_JS)])
            .then(function () {
                kontener.hidden = false;
                if (statyczna) { statyczna.hidden = true; }
                przycisk.hidden = true;
                rysuj();
            })
            .catch(function () {
                zaladowano = false;
                przycisk.disabled = false;
                przycisk.textContent = jst("mapa_js.f05b2fff3dcd");
            });
    });
})();
